module.exports = __webpack_public_path__ + "img/reference-arteverde.9c72cb7a.webp";